import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Defs, Path, Pattern, Rect, Use, Image } from 'react-native-svg';
import { MinusIconV2 } from './MinusIconV2';
import { UserItem } from '../../components/screens/MyHiveData/UserItem/UserItem';
const beeFriendIcon = require('../images/beeFriend.png');

const BeePlayAFriendHexagon = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 64}
          height={props.height ?? 61}
          viewBox="0 0 64 61"
          fill="none"
          {...props}
        >
          <Path
            d="M46.6582 45.8011C48.1578 44.9476 49.373 42.8269 49.373 41.094L49.373 18.9034C49.373 17.1706 48.1578 15.0757 46.6582 14.1963L27.4473 3.10105C25.9477 2.24757 23.5172 2.24757 22.0176 3.10105L2.80667 14.1963C1.30703 15.0498 0.0918 17.1706 0.0918 18.9034L0.091799 41.094C0.0917989 42.8269 1.30702 44.9218 2.80667 45.8011L22.0176 56.8964C23.5172 57.7499 25.9477 57.7499 27.4473 56.8964L46.6582 45.8011Z"
            fill="#FFB600"
            fillOpacity="0.22"
          />
          <Rect
            x="23.2656"
            y="0.0898438"
            width="40.3203"
            height="60.4805"
            fill="url(#pattern0_1_39126)"
          />
          <Defs>
            <Pattern
              id="pattern0_1_39126"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <Use
                xlinkHref="#image0_1_39126"
                transform="matrix(0.00377358 0 0 0.00251572 0 -0.0232704)"
              />
            </Pattern>
            <Image
              id="image0_1_39126"
              width="265"
              height="416"
              preserveAspectRatio="none"
              xlinkHref={beeFriendIcon}
            />
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { BeePlayAFriendHexagon };
